import { useState } from "react";

export const SearchInput = ({ value, onChange, placeholder = "Search", onSearch }) => {
  const [active, setActive] = useState(false);

  return (
    <div
      className="input-group custom-btn custom-input-group"
      onClick={() => setActive(true)}
      style={{
        display: "flex",
        border: `1px solid ${active ? "#00ABEF" : "#ced4da"}`,
        borderRadius: "6px",
        overflow: "hidden",
        height: "40px",
        transition: "border 0.2s",
      }}
    >
      <button
        type="button"
        onClick={onSearch}
        tabIndex={0}
        style={{
          cursor: "pointer",
          border: "none",
          backgroundColor: "white",
          padding: "0 12px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <i className="bi bi-search"></i>
      </button>
      <input
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onFocus={() => setActive(true)} 
        onBlur={() => setActive(false)}
        style={{
          border: "none",
          outline: "none",
          flex: 1,
          padding: "0 0px",
          fontSize: "14px",
          fontFamily: "sans-serif",
          width: "60px",
        }}
      />
    </div>
  );
};
